// /js/shared/handlers/handleUiChange.js
import { domExtensions } from '/js/shared/extensions/domExtensions.js';

export async function handleUiChange(event) {
	await domExtensions.handleUiChange(event);
}